import { type PropsWithChildren } from "react"
import { AnimatePresence, type Easing, motion, type Variants } from "framer-motion"

const EASE_IN_OUT: Easing = [0.4, 0, 0.2, 1] as const

const STEP_VARIANTS: Variants = {
    initial: { x: "-1.5%", opacity: 0 },
    animate: (delay: number) => ({
        x: "0%",
        opacity: 1,
        transition: { duration: 0.8, ease: EASE_IN_OUT, delay },
    }),
    exit: { x: "1.5%", opacity: 0, transition: { duration: 0.6, ease: EASE_IN_OUT } },
}

type EligibilityStepRevealProps = PropsWithChildren<{
    stepKey: number
    /**
     * The delay before the animation starts, in seconds.
     */
    delay?: number
}>

export function EligibilityStepReveal({
    stepKey,
    delay = 0,
    children,
}: EligibilityStepRevealProps) {
    return (
        <AnimatePresence mode="wait">
            <motion.div
                key={stepKey}
                custom={delay}
                variants={STEP_VARIANTS}
                initial="initial"
                animate="animate"
                exit="exit"
            >
                {children}
            </motion.div>
        </AnimatePresence>
    )
}
